import {Routes} from '@angular/router';

export const AppRoutes: Routes = [
    {
      path: '',
      loadChildren: () => import('./pages/inicio/inicio.module').then(m => m.InicioModule)
    },
    {
      path: 'cartera/:id',
      loadChildren: () => import('./pages/cartera-detail/cartera-detail.module').then(m => m.CarteraDetailModule)
    },
    {
      path: 'cuenta',
      loadChildren: () => import('./pages/cuenta/cuenta.module').then(m => m.CuentaModule)
    },
    {
      path: 'errors',
      loadChildren: () => import('./pages/errors/errors.module').then(m => m.ErrorsModule)
    },
    {
      path: '**',
      pathMatch: 'full',
      redirectTo: 'errors'
    }
];


